export class Usuario {
    ID !: number
    nombre !: string
    correo_electronico !: string
    password !: string
    tipo !: string
    edad !: number
    posicion !: string
    equipo_id !: number
    tipo_cuerpo_tecnico !: string
    token !: string
    avatar !: File
}
